import './vscode/src/vs/workbench/contrib/emmet/browser/actions/expandAbbreviation.js';

function getServiceOverride() {
    return {};
}

export { getServiceOverride as default };
